import environment from "../environment";
import { GET } from "./http.service";

const endpoint = environment.USER_ENDPOINT;
const _token = environment.TOKEN_KEY;

export const getAllNotifications = async () => {
  const response = await GET(`${endpoint}/notifications`, localStorage.getItem(_token));
  return response;
};